import type { XrefIntakes } from "@/composables/forms/formTypes";
import { LengthUnits } from "@/libs/units/length";
import { PercentageUnits } from "@/libs/units/percentage";
import { computeIntakeLabel } from "@/models/equipment/intake/properties";
import { arrayOfInts } from "@/utils/utils";
import type { RenderScenarioExportCols } from "./sizingExportTypes";

export const renderIntakeGasSeparatorCols: RenderScenarioExportCols = ({
  scenario,
  calcs,
  targetUnits,
  maxIntakes
}) =>
  arrayOfInts(maxIntakes).flatMap(i => {
    const section = calcs.isScenarioEspShore.value
      ? `Intake/Gas Separator ${i + 1}`
      : `Suction`;
    const intakeXref: XrefIntakes[number] | undefined =
      calcs.orderedIntakes.value[i];
    return [
      {
        section,
        label: "Model",
        targetUnit: null,
        value: computeIntakeLabel(
          intakeXref?.r_intake,
          intakeXref?.use_high_strength_shaft
        )
      },
      {
        section,
        label: "OD",
        targetUnit: LengthUnits.Inches,
        value: LengthUnits.Inches.toStandardUnit(
          intakeXref?.r_intake?.outer_diameter_inches
        )
      },
      {
        section,
        label: "Intake Length",
        targetUnit: targetUnits.largeLengthUnit,
        value: LengthUnits.Inches.toStandardUnit(
          intakeXref?.r_intake?.length_inches
        )
      },
      {
        section,
        label: "Intake Weight",
        targetUnit: targetUnits.massUnit,
        value: intakeXref?.r_intake?.weight_pounds
      },
      {
        section,
        label: "Intake Shaft Rating",
        targetUnit: targetUnits.hydraulicPowerUnit,
        value:
          calcs.intakeCalculations.individual.value[intakeXref?.id]
            ?.shaftPowerLimitStandardHP
      },
      {
        section,
        label: "% Intake Shaft Load",
        targetUnit: PercentageUnits.Percentage,
        value: scenario.equipment.value?.r_xref_intakes[i]
          ?.use_high_strength_shaft
          ? PercentageUnits.Ratio.toStandardUnit(
              calcs.intakeCalculations.individual.value[intakeXref?.id]
                ?.highStrengthShaftRatingRatio
            )
          : PercentageUnits.Ratio.toStandardUnit(
              calcs.intakeCalculations.individual.value[intakeXref?.id]
                ?.standardShaftRatingRatio
            )
      },
      {
        section,
        label: "Intake Shaft Limit (Std) @ 3500 RPM",
        targetUnit: targetUnits.hydraulicPowerUnit,
        value: intakeXref?.r_intake?.shaft_limit_hp
      },
      {
        section,
        label: "Intake Shaft Limit (HS) @ 3500 RPM",
        targetUnit: targetUnits.hydraulicPowerUnit,
        value: intakeXref?.r_intake?.high_strength_shaft_limit_hp
      }
    ];
  });
